module.exports = __webpack_public_path__ + "img/logoHundaicolor.f9830f37.png";